<script>

export default {
  name: 'CreateArtistOrder',
  data() {
    return {
      dialogFormVisible: false,
      dialogLoading: false,
      dialogArtistVisible: false,
      dialogTitle: '',
      dialogForm: {
        artist_id: '',
        nickname: '',
        type: '',
        exec_date: '',
        brand: '',
        product: '',
        exec_price: ''
      },
      typeMap:[

      ],
      dialogFormRules: {
        exec_date: [
          { required: true, message: '执行时间必填', trigger: 'change' }
        ],
        nickname: [
          { required: true, message: '请选择红人', trigger: 'change' }
        ],
        exec_price: [
          { required: true, message: '执行价必填', trigger: 'change' }
        ]
      },
      date_time: null,
      pickerOptions: {
        disabledDate: (time) => {
          // console.log('time',time.getTime(),this.date_time,this.dialogForm.exec_date)
          // 获取指定月份的第一天和最后一天
          const monthStart = new Date(this.date_time).getTime();
          const monthEnd = new Date(`${this.date_time} 23:59:59`).getTime();

          // 不在指定月份范围内的日期都禁用
          return time.getTime() < monthStart || time.getTime() > monthEnd;
        }
      }
    }
  },
  methods: {
    add(divideDetail) {
      this.dialogFormVisible = true
      this.dialogTitle = '新增红人订单明细'
      this.date_time = divideDetail.date_time
      this.dialogForm = {
        artist_id: divideDetail.artist_id,
        nickname: divideDetail.nickname,
        exec_date: `${divideDetail.date_time}`,
        brand: '',
        product: '',
        exec_price: 0
      }
    },
    async edit(row) {
      // 加载详情
      // await this.$api.getArtistDivide(id)
      this.dialogLoading = false
      this.dialogForm = { ...row }
      this.dialogFormVisible = true
      this.dialogTitle = `编辑红人(${row.nickname})订单明细`

    },
    moneyFormat(value) {
      return this.$utils.numberFormat(value, 2, '.', ',', 'round')
    },

    // 保留2位小数
    roundToTwo(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100
    },

    // 弹窗关闭时清空数据
    handleDialogClose() {
      this.dialogForm = {
        artist_id: '',
        nickname: '',
        exec_date: '',
        brand: '',
        product: '',
        exec_price: ''
      }
      // 清除表单验证状态
      if (this.$refs.dialogFormRef) {
        this.$refs.dialogFormRef.clearValidate()
      }
    },

    // 表单提交
    async handleSubmit() {
      this.$refs.dialogFormRef.validate(async (valid) => {
        if (valid) {
          this.dialogLoading = true
          try {
            setTimeout(() => {
              this.dialogLoading = false
            }, 1000)
            const data = await this.$api.addArtistOrder(this.dialogForm)
            if (data) {
              if (this.dialogForm.id) {
                this.msgSuccess('保存成功')
              } else {
                this.msgSuccess('新增成功')
                // this.$notify.success('新增成功')
              }
              this.dialogFormVisible = false

              this.$emit('saved', data)
            } else {
              this.$notify.error('新增失败')
            }
          } catch (error) {
            console.error('提交失败:', error)
            this.$notify.error('提交失败，请重试')
          } finally {
            this.dialogLoading = false
          }
        } else {
          this.dialogLoading = false
          this.$notify.warning('请填写必填项')
          return false
        }
      })
    }
  }

}

</script>

<template>
  <div>
    <el-dialog :title='dialogTitle' :visible.sync='dialogFormVisible' width='600px' @close='handleDialogClose'>

      <el-form :model='dialogForm'
               :rules='dialogFormRules'
               ref='dialogFormRef'
               label-width='100px'
               size='small'
               label-suffix='：'>
        <el-form-item label='红人昵称' prop='nickname'>
          {{ dialogForm.nickname || '' }}
        </el-form-item>
        <el-form-item label='执行时间' prop='exec_date'>
          <el-date-picker
            v-model='dialogForm.exec_date'
            type='date'
            value-format='yyyy-MM-dd'
            format='yyyy年MM月dd日'
            placeholder='选择执行时间'
            style='width: 100%'
          />
        </el-form-item>
        <el-form-item label='品牌' prop='brand'>
          <el-input v-model='dialogForm.brand' placeholder='品牌' maxlength='200' show-word-limit></el-input>
        </el-form-item>
        <el-form-item label='产品' prop='brand'>
          <el-input v-model='dialogForm.product' placeholder='品牌' maxlength='200' show-word-limit></el-input>
        </el-form-item>
        <el-form-item label='执行价' prop='brand'>
          <el-input-number
            v-model='dialogForm.exec_price'
            :precision='2'
            :min='0'
            placeholder='执行价'
            style='width: 100%'
          />
        </el-form-item>
      </el-form>

      <div slot='footer' class='dialog-footer'>
        <el-button @click='dialogFormVisible = false'>取 消</el-button>
        <el-button type='primary' @click='handleSubmit' :loading='dialogLoading' :disabled='dialogLoading'>确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>

</style>
